import React from 'react'
import { getRawLoginCookie } from '../common/js/login-cookie-utility'
import { createRoot } from 'react-dom/client';
import App from './App'

import { initI18N } from '../../i18next';

// the script import for the login js bundle will be in the
// base template within Hugo (layouts/_default/baseof.html)
// this will help prevent conflicts with multiple bundle script imports
// do not import this script anywhere else. 

const pageElement = document.getElementById('login-app');
const modalElement = document.getElementById('login-app-modal')
const login = getRawLoginCookie();

initI18N().then(() => {
    if (pageElement){
        let location;
        let pageData = pageElement.dataset;
        if (pageData.location != null){
            location = pageData.location;
        }
        const root = createRoot(pageElement);
        root.render(<App />);
    }

    //Do not attempt to load modal if user is already logged in
    if (modalElement && !login){
        let modalData = modalElement.dataset;
        let location;
        if (modalData.location){
            location = modalData.location;
        }
        const root = createRoot(modalElement);
        root.render(<App />);
    }
});
